import { render, staticRenderFns } from "./KsFormSection.vue?vue&type=template&id=7608cc48"
import script from "./KsFormSection.vue?vue&type=script&lang=js"
export * from "./KsFormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports